import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './DacLoginForm.css';
import React, { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { validateRequired, runValidations, validatePassword, validateRequiredCheckbox, validateAlphaNumericUsername, validateMaxLength, validateMinLength } from '../../Login/commomFunctions';
import FormField from '../../Login/components/FormField';
import Password from '../../Login/components/Password';
import Checkboxes from '../../Login/components/Checkboxes';
import InjectHTML from './InjectHTML';
import { getSessionId } from '../../DAcApplication/utils';
import Loader from '../../DAcApplication/components/loader';
import RouterLink from '../../atoms/RouterLink/RouterLink';
import { getDictionaryItem, get, canUseDOM } from '../../../utils';
import Modal from './Modal';
import AuthInvitationCode from './InvitationCode/AuthInvitationCode';
var DacLoginForm = function DacLoginForm(_ref) {
  var dictionary = _ref.dictionary,
    configuration = _ref.configuration,
    _ref$isLoginComponent = _ref.isLoginComponent,
    isLoginComponent = _ref$isLoginComponent === void 0 ? false : _ref$isLoginComponent,
    apiConfig = _ref.apiConfig,
    fieldsParams = _ref.fieldsParams;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    disableSubmit = _useState2[0],
    setDisableSubmit = _useState2[1];
  var sessionId = getSessionId('register');
  var usernameMaxLength = fieldsParams && fieldsParams.usernameMaxLength ? fieldsParams.usernameMaxLength : 20;
  var usernameMinLength = fieldsParams && fieldsParams.usernameMinLength ? fieldsParams.usernameMinLength : 3;
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    username = _useState4[0],
    setUsername = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorUsername = _useState6[0],
    setErrorUsername = _useState6[1];
  var usernameFieldProps = {
    value: username,
    fieldError: errorUsername,
    setError: setErrorUsername,
    label: getDictionaryItem(dictionary, 'username'),
    type: 'text',
    id: 'LoginUsername',
    name: 'LoginUsername',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'usernameRequired') || ' ',
    autoComplete: 'username',
    required: true,
    requiredFromContent: true,
    maxLength: usernameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'usernameMaxLengthError') || ' ',
    minLength: usernameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'usernameMinLengthError') || ' ',
    errorValue: getDictionaryItem(dictionary, 'usernameInvalid') || ' ',
    changeEvent: function changeEvent(value) {
      setUsername(value);
    },
    blurEvent: function blurEvent(value) {
      usernameFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : username;
      return runValidations([validateRequired, validateMaxLength, validateMinLength, validateAlphaNumericUsername], value, usernameFieldProps);
    }
  };
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    password = _useState8[0],
    setPassword = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    errorPassword = _useState10[0],
    setErrorPassword = _useState10[1];
  var passwordFieldProps = {
    value: password,
    fieldError: errorPassword,
    setError: setErrorPassword,
    label: getDictionaryItem(dictionary, 'password'),
    type: 'password',
    id: 'LoginPassword',
    name: 'LoginPassword',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'passwordRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'passwordIsNotValid') || ' ',
    autoComplete: 'current-password',
    required: true,
    requiredFromContent: true,
    changeEvent: function changeEvent(value) {
      setPassword(value);
    },
    blurEvent: function blurEvent(value) {
      passwordFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : password;
      return runValidations([validateRequired, validatePassword], value, passwordFieldProps);
    }
  };
  var _useState11 = useState([
    // {
    //   name: 'LoginEmailMarketing',
    //   id: 'LoginEmailMarketing',
    //   value: false,
    //   label: get(configuration, 'acceptEmailOrMessagesText.jss.value'),
    //   required: false,
    // },
    {
      name: 'LoginPrivacyPolicy',
      id: 'LoginPrivacyPolicy',
      value: false,
      label: get(configuration, 'acceptDGDPRAndPrivacyPolicyText.jss.value'),
      childrenHTML: /*#__PURE__*/React.createElement(InjectHTML, {
        htmlString: get(configuration, "acceptDGDPRAndPrivacyPolicyText.jss.value")
      }),
      required: true
      //   errorRequired: errorRequiredPrivacyPolicy,
    }]),
    _useState12 = _slicedToArray(_useState11, 2),
    checkboxes = _useState12[0],
    setCheckboxes = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    errorCheckboxes = _useState14[0],
    setErrorCheckboxes = _useState14[1];
  var checkboxesFieldProps = {
    checkboxes: checkboxes,
    fieldError: errorCheckboxes,
    setError: setErrorCheckboxes,
    errorRequired: '',
    changeEvent: function changeEvent(name, value) {
      var checkboxesCopy = checkboxes;
      checkboxesCopy = checkboxesCopy.filter(function (item) {
        if (item.name === name) {
          item.value = value;
        }
        return item;
      });
      setCheckboxes(checkboxesCopy);
      checkboxesFieldProps.validate();
      //   formFillAnalytics();
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkboxes;
      return runValidations([validateRequiredCheckbox], value, checkboxesFieldProps);
    }
  };
  useEffect(function () {
    if (username && !errorUsername && password && !errorPassword && checkboxes.filter(function (item) {
      return item.required;
    }).every(function (item) {
      return item.value;
    }) && !errorCheckboxes) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
    setAuthFailed('');
  }, [username, password, checkboxes, errorUsername, errorPassword, errorCheckboxes]);
  var urlRedirect = get(configuration, 'loginButton.jss.value.href');
  var formSubmit = function formSubmit(event) {
    event.preventDefault();
    authorizeUser();
  };
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    submitLoader = _useState16[0],
    setSubmitLoader = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    authFailed = _useState18[0],
    setAuthFailed = _useState18[1];
  var _useState19 = useState({}),
    _useState20 = _slicedToArray(_useState19, 2),
    tokenResult = _useState20[0],
    setTokenResult = _useState20[1];
  var authorizeUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url, headers, data, requestOptions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setSubmitLoader(function (prev) {
              return prev + 1;
            });
            setAuthFailed('');
            url = "".concat(apiConfig.apiUrl, "/v1/proxy/individual/authenticate");
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiConfig.apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
            headers.append('Access-Control-Allow-Origin', '*');
            data = {
              username: username,
              password: password
            };
            requestOptions = {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(data)
            };
            _context.next = 14;
            return fetch(url, requestOptions).then(function (response) {
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                setAuthFailed(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('access_token')) {
                setTokenResult(result);
                // call next step for submitting invitation code
                // getUserStatus(); //run in useEffect
              }
            }).catch(function (error) {
              console.error('authorizeUser error', error);
              setAuthFailed(error.message);
            }).finally(function () {
              return setSubmitLoader(function (prev) {
                return prev - 1;
              });
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function authorizeUser() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (tokenResult.access_token) {
      getUserStatus();
    }
  }, [tokenResult]);
  var getUserStatus = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var url, headers, requestOptions;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setSubmitLoader(function (prev) {
              return prev + 1;
            });
            url = "".concat(apiConfig.apiUrl, "/v1/orc/user/").concat(username, "/status");
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiConfig.apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', "Bearer ".concat(tokenResult.access_token));
            headers.append('Host', 'dacqa.detsandbox.com');
            headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
            requestOptions = {
              method: 'GET',
              headers: headers,
              redirect: 'follow',
              keepalive: true,
              withCredentials: true
            };
            _context2.next = 13;
            return fetch(url, requestOptions).then(function (response) {
              if (response.status == 401) {}
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                setAuthFailed(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
                console.error(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('status')) {
                if (result.status === false) {
                  setShowModal(true);
                } else {
                  callAfterSubmit();
                }
              }
            }).catch(function (error) {
              setAuthFailed(error.message);
              console.error('User Status error', error);
            }).finally(function () {
              return setSubmitLoader(function (prev) {
                return prev - 1;
              });
            });
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getUserStatus() {
      return _ref3.apply(this, arguments);
    };
  }();
  var redirectToUrl = function redirectToUrl(pathToRedirect) {
    if (canUseDOM) {
      window.location.href = pathToRedirect;
    }
  };
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showModal = _useState22[0],
    setShowModal = _useState22[1];
  useEffect(function () {
    if (showModal) {
      document.body.classList.add('prevent-scroll');
    } else {
      document.body.classList.remove('prevent-scroll');
    }
    return function () {
      document.body.classList.remove('prevent-scroll');
    };
  }, [showModal]);
  var insertCookies = function insertCookies() {
    var expirationDate = new Date(tokenResult.expires_on).getTime();
    var currentDate = new Date().getTime();
    var daysUntilExpiration = Math.round((expirationDate - currentDate) / (1000 * 3600 * 24));
    Cookies.set('token', "Bearer ".concat(tokenResult.access_token), {
      expires: daysUntilExpiration,
      secure: true
    });
    Cookies.set('username', username, {
      expires: daysUntilExpiration,
      secure: true
    });
  };
  var callAfterSubmit = function callAfterSubmit() {
    insertCookies();
    redirectToUrl(urlRedirect);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("form", {
    className: "dac-login-form",
    onSubmit: function onSubmit(event) {
      return formSubmit(event);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorUsername ? 'invalid-field' : '')
  }, /*#__PURE__*/React.createElement(FormField, usernameFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorPassword ? 'invalid-field' : '')
  }, /*#__PURE__*/React.createElement(Password, passwordFieldProps)))), /*#__PURE__*/React.createElement("p", {
    className: "dac-login-form__forgot"
  }, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: get(configuration, "forgotText.jss.value")
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-elements dac-login-form__checkboxes"
  }, /*#__PURE__*/React.createElement(Checkboxes, checkboxesFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__submit-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    type: "submit",
    disabled: disableSubmit || Boolean(submitLoader)
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: Boolean(submitLoader) ? 0 : 1
    }
  }, get(configuration, 'loginButton.jss.value.text')), Boolean(submitLoader) ? /*#__PURE__*/React.createElement(Loader, null) : false), authFailed && /*#__PURE__*/React.createElement("b", {
    className: "dac-login-form__error"
  }, authFailed)), isLoginComponent && /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__register"
  }, /*#__PURE__*/React.createElement("b", null, "Don\u2019t have an account?", ' ', /*#__PURE__*/React.createElement(RouterLink, {
    className: '',
    href: '#'
  }, 'Create one to Apply')))), showModal && /*#__PURE__*/React.createElement(Modal, {
    hide: function hide() {
      return setShowModal(false);
    },
    dictionary: dictionary,
    rtl: rtl,
    title: get(configuration, 'invitationSectionTitle.jss.value'),
    description: get(configuration, 'invitationSectionDescription.jss.value'),
    children: /*#__PURE__*/React.createElement(AuthInvitationCode, {
      dictionary: dictionary,
      configuration: configuration,
      apiConfig: apiConfig,
      sessionId: sessionId,
      hide: function hide() {
        return setShowModal(false);
      },
      callAfterSubmit: callAfterSubmit,
      rtl: rtl,
      username: username
    })
  }));
};
export default DacLoginForm;
var commonStyles = "c1g5msba";
var ltrStyles = "l1ebb8uv";
var rtlStyles = "r189k0v3";